import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getMonitoringTransactions = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/monitoring/transactions`
  return apiGet({ url, token, params })
}

export default function useAnalyticsMonitoringTransactions({
  params,
  options = {}
}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id }
  const queryFn = () => getMonitoringTransactions(token, mergedParams)
  const queryKey = ['analytics-monitoring-transactions', mergedParams]

  return useQuery(queryKey, queryFn, {
    // A workflow is scoped server-side, so it stands in for a section_id.
    enabled: Boolean(params.section_id || params.workflow),
    ...options
  })
}
